import { gql } from 'apollo-boost';

const createContactMutation = gql`
  mutation createContactMutation($contact: ContactCreateInput!) {
    contact {
      create(contact: $contact) {
        id
        email
        firstName
        lastName
        phone
        active
        rowVersion
      }
    }
  }
`;

const updateContactMutation = gql`
  mutation updateContactMutation($contact: ContactUpdateInput!) {
    contact {
      update(contact: $contact) {
        id
        rowVersion
        email
        firstName
        lastName
        phone
        active
      }
    }
  }
`;

const deleteContactMutation = gql`
  mutation deleteContactMutation($contactId: Int!) {
    contact {
      delete(contactId: $contactId)
    }
  }
`;

export { createContactMutation, updateContactMutation, deleteContactMutation };
